import React, { useEffect } from "react";
import { FaReact, FaPython } from "react-icons/fa";
import { SiDjango, SiJavascript, SiPostgresql } from "react-icons/si";
import { BsFillBootstrapFill } from "react-icons/bs";
import { IoLogoCss3 } from "react-icons/io";
import { AiFillHtml5, AiFillGithub } from "react-icons/ai";
import { DiGit, DiFirebase, DiCodeBadge } from "react-icons/di";
import { GrHeroku } from "react-icons/gr";
import { VscLiveShare } from "react-icons/vsc";
import Flip from "react-reveal/Flip";
import Aos from "aos";

const MyWork = () => {
  return (
    <div class="work" id="work">
      <div className="container">
        <div className="common col-sm-12">
          <h1 className="main-header">My Work</h1>
          <p className="text-muted">
            More on my work experience detailed on my CV.{" "}
            <a href="/images/johannes kgatle CV.pdf" download>
              click here
            </a>
          </p>
          <h3 className="heading">My Projects</h3>
          <p className="main-content">
            Checkout my latest projects, samples of my work.
          </p>
        </div>

        <div class="row">
          <div data-aos="fade-up" class="col-md-6 col-md-offset-3">
            <div className="work-box">
              <img className="float-right" src="/images/SAvarsity.ico"></img>
              <a
                href="https://github.com/Jay-dev-creator/weather-web-app.git"
                target="_blank"
                className="h1"
              >
                SA Varsity Site
              </a>
              <p>
                Gets the user's current location, then calculates and displays
                the distance between the user's location and 13 other
                universities in South Africa along with information about
                them.&nbsp;&nbsp;
                <a
                  className="p-2"
                  href="https://github.com/Jay-dev-creator/SA-Varsity-site.git"
                  target="_blank"
                >
                  read more...
                </a>
                <br />
                <br />
                <FaReact className="ml-2" size={20} />
                <AiFillHtml5 className="ml-2" size={20} />
                <IoLogoCss3 className="ml-1" size={20} />
                <BsFillBootstrapFill className="ml-2" size={20} />
                <DiFirebase className="ml-2" size={20} />
              </p>
              <a
                href="https://github.com/Jay-dev-creator/SA-Varsity-site.git"
                target="_blank"
                type="button"
                className="btn btn--outline btn--medium"
              >
                code
                <AiFillGithub className="fa-play-circle" />
              </a>
              <a
                href="https://sa-varsity-site.firebaseapp.com/"
                target="_blank"
                type="button"
                className="btn btn--outline btn--medium"
              >
                live
                <VscLiveShare className="fa-play-circle" />
              </a>
            </div>
          </div>
        </div>
        <div class="row">
          <div data-aos="fade-up" class="col-md-6 col-md-offset-3">
            <div className="work-box">
              <img className="float-right" src="/images/weatherapp.png"></img>
              <a
                href="https://github.com/Jay-dev-creator/weather-web-app.git"
                target="_blank"
                className="h1"
              >
                Weather App
              </a>
              <p>
                provides the temperature and visibility for a searched specific
                region at that time.&nbsp;&nbsp;
                <a
                  className="p-2"
                  href="https://github.com/Jay-dev-creator/weather-web-app.git"
                  target="_blank"
                >
                  read more...
                </a>
                <br />
                <br />
                <FaReact className="ml-2" size={20} />
                <AiFillHtml5 className="ml-2" size={20} />
                <IoLogoCss3 className="ml-1" size={20} />
                <BsFillBootstrapFill className="ml-2" size={20} />
                <DiFirebase className="ml-2" size={20} />
              </p>
              <a
                href="https://github.com/Jay-dev-creator/weather-web-app.git"
                target="_blank"
                type="button"
                className="btn btn--outline btn--medium"
              >
                code
                <AiFillGithub className="fa-play-circle" />
              </a>
              <a
                href="https://weather-app-82754.firebaseapp.com/"
                target="_blank"
                type="button"
                className="btn btn--outline btn--medium"
              >
                live
                <VscLiveShare className="fa-play-circle" />
              </a>
            </div>
          </div>
        </div>
        <div class="row">
          <div data-aos="fade-up" class="col-md-6 col-md-offset-3">
            <div className="work-box">
              <img className="float-right" src="/images/hdef.png"></img>
              <a
                href="https://github.com/Jay-dev-creator/HDEFapp.git"
                target="_blank"
                className="h1"
              >
                HDEF App
              </a>
              <p>
                A web application for an organization that accepts donations
                from external donors and offers tuition to University of Limpopo
                students. &nbsp;&nbsp;
                <a
                  className="p-2"
                  href="https://github.com/Jay-dev-creator/HDEFapp.git"
                  target="_blank"
                >
                  read more...
                </a>
                <br />
                <br />
                <SiDjango size={20} />
                <AiFillHtml5 size={20} />
                <IoLogoCss3 size={20} />
                <BsFillBootstrapFill size={20} />
              </p>
              <a
                href="https://github.com/Jay-dev-creator/HDEFapp.git"
                target="_blank"
                type="button"
                className="btn btn--outline btn--medium"
              >
                code
                <AiFillGithub className="fa-play-circle" />
              </a>
            </div>
          </div>
        </div>

        <div class="row">
          <div data-aos="fade-up" class="col-md-6 col-md-offset-3">
            <div className="work-box">
              <img className="float-right" src="/images/racinggame.png"></img>
              <a
                href="https://github.com/Jay-dev-creator/Arcade-racing-game.git"
                target="_blank"
                className="h1"
              >
                Arcade Racing Game
              </a>
              <p>
                An arcade racing game, created using pygame, a python library
                used for game development &nbsp;&nbsp;
                <a
                  className="p-2"
                  href="https://github.com/Jay-dev-creator/Arcade-racing-game.git"
                  target="_blank"
                >
                  read more...
                </a>
                <br />
                <br />
                <FaPython className="ml-2" size={20} />
              </p>
              <a
                href="https://github.com/Jay-dev-creator/Arcade-racing-game.git"
                target="_blank"
                type="button"
                className="btn btn--outline btn--medium"
              >
                code
                <AiFillGithub className="fa-play-circle" />
              </a>
            </div>
          </div>
        </div>
        <div class="row">
          <div data-aos="fade-up" class="col-md-6 col-md-offset-3">
            <div className="work-box">
              <img className="float-right" src="/images/polling.png"></img>
              <a
                href="https://jayempolls.herokuapp.com/"
                target="-blank"
                className="h1"
              >
                Polling App
              </a>
              <p>
                A polling web application in which users can participate in
                answering questionnaires(Voting) created by the administrator,
                then displays the statistics on how many people voted.
                &nbsp;&nbsp;
                <a
                  className="p-2"
                  href="https://github.com/Jay-dev-creator/jayempolls.git"
                  target="_blank"
                >
                  read more...
                </a>
                <br />
                <br />
                <SiDjango className="ml-2" size={20} />
                <AiFillHtml5 className="ml-2" size={20} />
                <IoLogoCss3 className="ml-1" size={20} />
                <BsFillBootstrapFill className="ml-2" size={20} />
                <GrHeroku className="ml-2" size={20} />
              </p>
              <a
                href="https://github.com/Jay-dev-creator/jayempolls.git"
                target="_blank"
                type="button"
                className="btn btn--outline btn--medium"
              >
                code
                <AiFillGithub className="fa-play-circle" />
              </a>
              <a
                href="https://jayempolls.herokuapp.com/"
                target="-blank"
                type="button"
                className="btn btn--outline btn--medium"
              >
                live
                <VscLiveShare className="fa-play-circle" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

/*

const MyWork = () => {
  useEffect(() => {
    Aos.init({ duration: 1000 });
  }, []);
  return (
    <div class="work lobster-font-family" id="work">
      <div class="container">
        <div className="common col-sm-12">
          <h3 className="heading">My work</h3>
          <h1 className="main-header">Projects</h1>
          <p className="main-content">
            Checkout my latest projects, samples of my work.
          </p>
          <div className="common-border"></div>
        </div>
        <div class="row">
          <div data-aos="fade-up" class="col-lg-4 col-12">
            <div
              class="img"
              style={{ backgroundImage: 'URL("/images/weatherapp.png")' }}
            ></div>
          </div>
          <div class="col-lg-8 col-12 mb-2">
            <div data-aos="fade-right" class="block">
              <div>
                <img src="/images/jayempolls.png" alt="img"></img>
                <strong>Weather App</strong>
                <h5>Web application with weather API</h5>
                <p className="text-secondary">
                  An app that provides the temperature and visibility for a
                  searched specific region at that time. It uses the weather API
                  to extract data about the weather and time. It was created
                  using ReactJS, bootstrap, HTML5/CSS, and hosted using
                  firebase.
                </p>
                <FaReact className="text-secondary ml-2" size={20} />
                <AiFillHtml5 className="text-secondary ml-2" size={30} />
                <IoLogoCss3 className="text-primary ml-1" size={30} />
                <BsFillBootstrapFill className="text-info ml-2" size={30} />
                <SiJavascript className="text-secondary ml-2" size={30} />
                <DiFirebase className="text-primary ml-2" size={30} />
                <div className="pt-3">
                  <a
                    href="https://weather-app-82754.firebaseapp.com/"
                    target="_blank"
                  >
                    <button className="btn btn-secondary mr-2">
                      <VscLiveShare />
                    </button>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div data-aos="fade-up" class="col-lg-4 col-12">
            <div
              class="img"
              style={{ backgroundImage: 'URL("/images/hdef.png")' }}
            ></div>
          </div>
          <div class="col-lg-8 col-12 mb-2">
            <div data-aos="fade-right" class="block">
              <div>
                <img src="/images/jayempolls.png" alt="img"></img>
                <strong>HDEF App</strong>
                <h5>Higher Destiny Educational Foundation</h5>
                <p className="text-secondary">
                  HDEF web app is a website for an organization that accepts
                  donations from external donors and offers tuition to
                  University of Limpopo students. This was part of our final
                  year project, the main function of the application includes
                  capturing information about the users and the items donated.
                  PostgraSQL was used as our main database to store important
                  information about the donors and the products donated. It was
                  created using Django, JavaScript, bootstrap, HTML5/CSS, and
                  PostgreSQL database.
                </p>
                <SiDjango className="text-success ml-2" size={30} />
                <FaPython className="text-secondary ml-2" size={30} />
                <AiFillHtml5 className="text-danger ml-2" size={30} />
                <IoLogoCss3 className="text-primary ml-1" size={30} />
                <BsFillBootstrapFill className="text-info ml-2" size={30} />
                <SiJavascript className="text-secondary ml-2" size={30} />
                <SiPostgresql className="text-primary ml-2" size={30} />
                <div className="pt-3"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div data-aos="fade-up" class="col-lg-4 col-12">
            <div
              class="img"
              style={{ backgroundImage: 'URL("/images/racinggame.png")' }}
            ></div>
          </div>
          <div class="col-lg-8 col-12 mb-2">
            <div data-aos="fade-right" class="block">
              <div>
                <img src="/images/jayempolls.png" alt="img"></img>
                <strong>Arcade Racing Game</strong>
                <h5>Arcade style racing windows game.</h5>
                <p className="text-secondary">
                  A simple arcade racing game, created using pygame, a python
                  library used for game development
                </p>
                <FaPython className="text-secondary ml-2" size={30} />
                <div className="pt-3">
                  <a
                    href="https://github.com/Jay-dev-creator/Arcade-racing-game.git"
                    target="_blank"
                  >
                    <button className="btn btn-secondary mr-2">
                      <DiCodeBadge />
                    </button>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div data-aos="fade-up" class="col-lg-4 col-12">
            <div
              class="img"
              style={{ backgroundImage: 'URL("/images/jayempolls.png")' }}
            ></div>
          </div>
          <div class="col-lg-8 col-12 mb-2">
            <div data-aos="fade-right" class="block">
              <div>
                <img src="/images/jayempolls.png" alt="img"></img>
                <strong>JAYEMPOLLS</strong>
                <h5>A polling web app.</h5>
                <p className="text-secondary">
                  A simple polling web app in which users can participate in
                  questionnaires created by the administrator. Was developed and
                  hosted using Django(Python), HTML, CSS, Bootstrap and
                  Javascript
                </p>
                <SiDjango className="text-success ml-2" size={30} />
                <FaPython className="text-secondary ml-2" size={30} />
                <AiFillHtml5 className="text-danger ml-2" size={30} />
                <IoLogoCss3 className="text-primary ml-1" size={30} />
                <BsFillBootstrapFill className="text-info ml-2" size={30} />
                <SiJavascript className="text-secondary ml-2" size={30} />
                <GrHeroku className="text-primary ml-2" size={30} />
                <div className="pt-3">
                  <a href="https://jayempolls.herokuapp.com/" target="_blank">
                    <button className="btn btn-secondary mr-2">
                      <VscLiveShare />
                    </button>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div data-aos="fade-up" class="col-lg-4 col-12">
            <div
              class="img"
              style={{ backgroundImage: 'URL("/images/todo.png")' }}
            ></div>
          </div>
          <div class="col-lg-8 col-12 mb-2">
            <div data-aos="fade-right" class="block">
              <div>
                <img src="/images/jayempolls.png" alt="img"></img>
                <strong>To-do App</strong>
                <h5>A to-do list web application</h5>
                <p className="text-secondary">
                  The to-do list web app is a web application that keeps a
                  record of tasks that the user wants to complete, the
                  functionality of the application includes adding, deleting,
                  updating, and marking tasks as completed. It was developed
                  using Django(Python), HTML, CSS, Bootstrap, and JavaScript,
                  hosted using Heroku hosting server.
                </p>
                <SiDjango className="text-success ml-2" size={30} />
                <FaPython className="text-secondary ml-2" size={30} />
                <AiFillHtml5 className="text-danger ml-2" size={30} />
                <IoLogoCss3 className="text-primary ml-1" size={30} />
                <BsFillBootstrapFill className="text-info ml-2" size={30} />
                <SiJavascript className="text-secondary ml-2" size={30} />
                <GrHeroku className="text-primary ml-2" size={30} />
                <div className="pt-3">
                  <a
                    href="https://mytodolistweb.herokuapp.com/"
                    target="_blank"
                  >
                    <button className="btn btn-secondary mr-2">
                      <VscLiveShare />
                    </button>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
*/

export default MyWork;
